import React from "react";
import translate from "../../Utils/translate";
import BasePrompt from "./BasePrompt";

export default function SuccessPrompt({ prompt }) {
  const title = prompt?.title ?? translate("success.message");
  return (
    <BasePrompt className="bg-green-200 text-neutral-600 border border-green-500" promptId={prompt?.id}>
      <h2>
        {title} {prompt?.status}
      </h2>
      <p>{prompt?.serverMessage}</p>
    </BasePrompt>
  );
}
